module.exports = __webpack_public_path__ + "img/asset_edit_white.bbb3d45a.svg";